export function getDatetimeYear(datetime: string): string {
  return new Date(datetime).getFullYear().toString();
}

export function calculateEconomicCarbonIntensity(
  carbon: number,
  turnover: number
): number {
  return carbon / (turnover / 100000.0);
}

export function calculateSocialCarbonIntensity(
  carbon: number,
  employees: number
): number {
  return carbon / employees;
}

export function descendingSort(a: number, b: number) {
  return b - a;
}

export function ascendingSort(a: number, b: number) {
  return a - b;
}

export async function copyToClipboard(data: string) {
  try {
    navigator.clipboard.writeText(data);
  } catch (error) {
    console.error(error);
  }
}

export function isEven(value: number) {
  return value % 2 === 0;
}
